import React from "react";
import "./Setup.css";
import { useTheme } from "@mui/material/styles";
import { Button, Container, CssBaseline, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import InfiniteTable from "../../components/InfiniteTable/InfiniteTable";

const columns = [
  {
    id: "id",
    editable: "/warehouse",
    editablePk: "id",
    label: "Warehouse ID",
  },
  { id: "name", label: "Name" },
];

const data = [
  {
    id: 1,
    name: "Restaurant Depot",
  },
];

export const Setup = (props) => {
  const theme = useTheme();

  return (
    <>
      <CssBaseline />
      <Container style={{ textAlign: "right", marginBottom: theme.spacing(3) }}>
        <Link
          to="/warehouses/add"
          style={{ textDecoration: "none" }}
          color="secondary"
        >
          <Button variant="contained" color="primary">
            <Typography variant="subtitle2" className="text-white">
              Add Warehouse
            </Typography>
          </Button>
        </Link>
      </Container>
      <Container>
        <InfiniteTable
          {...props}
          // apiep="/warehouses/"
          columns={columns}
          data={data}
          dataMapByColumn="id"
          deletable={false}
          editable={true}
          filterable={true}
          label="Warehouses"
          fetchingModal={null}
        />
      </Container>
    </>
  );
};

export default Setup;
